import axiosInstance from 'api/axiosInstance';

const createRepoDocument = (params: { filename: string; name: string }) =>
  axiosInstance.post('/v2/repository-documents', params);

export default createRepoDocument;
